import { render, staticRenderFns } from "./DataListRiskZoneAssessements.vue?vue&type=template&id=92f0b1c8&scoped=true&"
import script from "./DataListRiskZoneAssessements.vue?vue&type=script&lang=js&"
export * from "./DataListRiskZoneAssessements.vue?vue&type=script&lang=js&"
import style0 from "./DataListRiskZoneAssessements.vue?vue&type=style&index=0&id=92f0b1c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f0b1c8",
  null
  
)

export default component.exports